// Shared constants for cross-layer constraints
// Prefer reusing these in Zod schemas, UI inputs, and DB schema lengths

export const CODE_MAX = 10 as const
export const ROUTE_CODE_MAX = 15 as const
